export default {
    paletteNameInput:{
        width:"100%"
    }
}